import * as Yup from 'yup';

export const formLearnerSchema = Yup.object().shape({
  nickname: Yup.string(),
  name: Yup.string(),
  firstName: Yup.string(),
  lastName: Yup.string().min(1).required(),
  gender: Yup.string(),
  phone: Yup.string().required(),
  password: Yup.string().min(6),
});

export const formUpdateLearnerSchema = Yup.object().shape({
  name: Yup.string(),
  password: Yup.string().min(6),
});
